import { render, staticRenderFns } from "./MoleculeEditionBillingMyPaymentsModalChangePlan.vue?vue&type=template&id=346becb6&"
import script from "./MoleculeEditionBillingMyPaymentsModalChangePlan.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionBillingMyPaymentsModalChangePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports